import { render, staticRenderFns } from "./DeleteFileDialog.vue?vue&type=template&id=7f01a937&v-slot%3Amodal-body=true&"
import script from "./DeleteFileDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports